export function pluralizeRoomType(roomType) {
  switch (roomType) {
    case "ateljé":
      return "ateljér";
    case "behandlingsrum":
      return "behandlingsrum";
    case "eventlokal":
      return "eventlokaler";
    case "idrott&danslokal":
      return "idrott och danslokaler";
    case "klassrum":
      return "klassrum";
    case "kontorslokal":
      return "kontorslokaler";
    case "kontorshotell&co-working":
      return "kontorshotell och co-working lokaler";
    case "matsal&kök":
      return "matsalar och kök";
    case "musiksal":
      return "musiksalar";
    case "möteslokal":
      return "möteslokaler";
    case "pop-up":
      return "pop-up lokaler";
    case "studio":
      return "studios";
    case "teaterlokal":
      return "teaterlokaler";
    case "övrigt":
      return "övriga lokaler";
    case "biograf":
      return "biografer";
    case "kyrka":
      return "kyrkor";
    case "lager&logistik":
      return "lager och logistik lokaler";
    default:
      return roomType;
  }
}

/**
 * Adds definite article suffix to a pluralized room type
 * @param {string} pluralRoomType - The pluralized room type (e.g., "kontorslokaler")
 * @returns {string} Room type with definite article (e.g., "kontorslokalerna")
 */
export function addDefiniteArticle(pluralRoomType) {
  // Handle special cases that don't follow standard patterns
  if (pluralRoomType === "lokaler") return "lokalerna";
  if (pluralRoomType === "övriga lokaler") return "övriga lokalerna";
  if (pluralRoomType.includes(" och ")) {
    // For compound types with "och", add article to the end
    return pluralRoomType + "na";
  }

  // Standard patterns for Swedish definite articles
  if (pluralRoomType.endsWith("er")) {
    return pluralRoomType + "na"; // kontorslokaler -> kontorslokalerna
  } else if (pluralRoomType.endsWith("or")) {
    return pluralRoomType + "na"; // kyrkor -> kyrkorna
  } else if (pluralRoomType.endsWith("ar")) {
    return pluralRoomType + "na"; // musiksalar -> musiksalarna
  } else if (pluralRoomType.endsWith("r")) {
    return pluralRoomType + "na"; // ateljér -> ateljérna
  } else if (pluralRoomType.endsWith("s")) {
    return pluralRoomType; // studios -> studios (unchanged)
  } else if (pluralRoomType.endsWith("rum")) {
    return pluralRoomType + "men"; // behandlingsrum -> behandlingsrummen, klassrum -> klassrummen
  } else {
    // Default fallback
    return pluralRoomType + "na";
  }
}

/**
 * Formats a number with Swedish thousand separators (spaces)
 * @param {number} num - The number to format
 * @returns {string} Formatted number with space separators (e.g., 1000 -> "1 000")
 */
export function formatNumber(num) {
  if (num == null || isNaN(num)) return num;

  // Only add space separators for numbers >= 1000
  if (num < 1000) return num.toString();

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
